module.exports = __webpack_public_path__ + "static/media/students-icon-active.1988aedb.svg";